import { HotelMapLoader } from './HotelMapLoader';

export default HotelMapLoader;
